"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getThemeByTreeId = exports.getTreesLabelByIds = exports.cleanBlocks = exports.getPathTitles = void 0;
var models_1 = require("@livv/models");
var treeDatas_1 = require("@livv/models/treeDatas");
var text_1 = require("./text");
var getPathTitles = function (path, tree) {
    var fallBack = ['[Thème non répertorié]'];
    if (!tree)
        return fallBack;
    try {
        var treeData = new treeDatas_1.TreeData(tree.content, tree.title);
        return __spreadArray([tree.title], __read(treeData.getPathTitles(path)), false);
    }
    catch (err) {
        console.error(err);
        return fallBack;
    }
};
exports.getPathTitles = getPathTitles;
var cleanBlocks = function (blocks, cleanQuotes, isNote) {
    if (isNote === void 0) { isNote = false; }
    return blocks.map(function (block) { return (__assign(__assign(__assign({}, block), { text: cleanQuotes ? (0, text_1.cleanTextQuotes)(block.text) : block.text }), (isNote ? { entityRanges: [] } : {}))); });
};
exports.cleanBlocks = cleanBlocks;
var getTreesLabelByIds = function (trees) {
    return Object.entries(trees).reduce(function (treesIdsAndLabel, _a) {
        var _b;
        var _c = __read(_a, 2), id = _c[0], title = _c[1].title;
        return (__assign(__assign({}, treesIdsAndLabel), (_b = {}, _b[id] = title, _b)));
    }, {});
};
exports.getTreesLabelByIds = getTreesLabelByIds;
var getThemeByTreeId = function (db, treeId) { return __awaiter(void 0, void 0, void 0, function () {
    var treeRef, treeRecord, theme;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, db
                    .collection(models_1.CollectionName.TREES)
                    .doc(treeId)
                    .get()];
            case 1:
                treeRef = (_a.sent());
                if (!treeRef.exists) {
                    throw new Error("Tree with id ".concat(treeId, " does not exist"));
                }
                treeRecord = treeRef.data();
                theme = treeRecord.theme;
                return [2 /*return*/, theme];
        }
    });
}); };
exports.getThemeByTreeId = getThemeByTreeId;
//# sourceMappingURL=trees.js.map